import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_ENDPOINT; 

export const getSubmitDec = createAsyncThunk(
    'submit-dec', 
    async (item, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');

            const response = await axios.get(`${API_URL}/submit-dec/${item.spk_number}/${item.so_number}`, {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
            });
            
            return response.data.data;
        } catch (error) {
            console.error('Error get submit_dec:', error);
            return rejectWithValue(error.response?.data || 'Failed to get submit dec');
        }
    }
);

export const createPreDec = createAsyncThunk(
    'submit-dec/pre-dec/store-update', 
    async (item, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');
            
            const response = await axios.post(`${API_URL}/submit-dec/pre-dec/store-update`, item, {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
            }); 
            
            return response.data; 
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to create item');
        }
    }
);
export const createDec = createAsyncThunk(
    'submit-dec/dec/store-update', 
    async (item, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');
            
            const response = await axios.post(`${API_URL}/submit-dec/dec/store-update`, item, {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
            }); 
            
            return response.data; 
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to create item');
        }
    }
);

const submitDecSlice = createSlice({
    name: 'submitDec',
    initialState: {
        submit_dec: [],
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(getSubmitDec.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(getSubmitDec.fulfilled, (state, action) => {
            state.isLoading = false;
            state.submit_dec = action.payload;
        })
        .addCase(getSubmitDec.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(createPreDec.fulfilled, (state, action) => {
            state.submit_dec.predec = action.payload.data;
        })
        .addCase(createDec.fulfilled, (state, action) => {
            state.submit_dec.dec = action.payload.data;
        });
    },
});

export default submitDecSlice.reducer;
